import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getManagedReturnsOverviewMetrics = unaryRpc({
  name: "getManagedReturnsOverviewMetrics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
  }),
  output: z.object({
    returnsProcessedCount: z.number(),
    returnsProcessedValueCents: z.number(),

    consolidatedShipmentsCount: z.number(),
    consolidatedItemsValueCents: z.number(),

    fraudAndLossPreventedValueCents: z.number(),
    returnsFlaggedCount: z.number(),
    damagedItemsCount: z.number(),
    damagedItemsValueCents: z.number(),
    missingItemsCount: z.number(),
    missingItemsValueCents: z.number(),

    processingSlaAverageDays: z.number().nullable(),
  }),
});

export type ManagedReturnsOverviewMetricsOutput = z.infer<
  (typeof getManagedReturnsOverviewMetrics)["output"]
>;

export const getOverviewRefulfillmentMetrics = unaryRpc({
  name: "getOverviewRefulfillmentMetrics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
  }),
  output: z.object({
    refulfillmentCount: z.number(),
    refulfillmentValueCents: z.number(),
    fulfillmentSlaAverageDays: z.number().nullable(),
  }),
});

export type OverviewRefulfillmentMetricsOutput = z.infer<
  (typeof getOverviewRefulfillmentMetrics)["output"]
>;
